import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconThumbUp = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3337 4.33325C10.9385 4.33325 10.5803 4.56599 10.4198 4.92711L8.01712 10.3333H6.66634C5.37768 10.3333 4.33301 11.3779 4.33301 12.6666V17.3333C4.33301 18.6219 5.37768 19.6666 6.66634 19.6666H8.66634C8.66681 19.6666 8.66727 19.6666 8.66774 19.6666H16.1821C17.3425 19.6766 18.3345 18.831 18.509 17.6832L19.4288 11.6848L19.429 11.6833C19.5317 11.0065 19.332 10.3187 18.8828 9.80208C18.435 9.28711 17.7843 8.99407 17.1021 8.99992H14.3337V7.33325C14.3337 5.6764 12.9905 4.33325 11.3337 4.33325ZM9.66699 11.5455L11.9042 6.51185C12.1638 6.69248 12.3337 6.99302 12.3337 7.33325V9.99992C12.3337 10.5522 12.7814 10.9999 13.3337 10.9999L17.107 11L17.1183 10.9999C17.2161 10.9987 17.3095 11.0406 17.3736 11.1144C17.4376 11.1881 17.4661 11.2867 17.4516 11.3832L16.5316 17.3833C16.5067 17.5477 16.3645 17.6685 16.1983 17.6666H9.66699V11.5455ZM6.33301 12.6666C6.33301 12.4825 6.48225 12.3333 6.66634 12.3333H7.66634V17.6666H6.66634C6.48225 17.6666 6.33301 17.5173 6.33301 17.3333V12.6666Z"
        />
      </svg>
    );
  }
);
